module.exports = __webpack_public_path__ + "cc9402e4468091409e6470e026d155e3.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/shirt-surfboards.png
// module id = 1939
// module chunks = 0